import ReactDatePicker from "react-datepicker";
import ptBR from "date-fns/locale/pt-BR";

import "./style.css";

interface Props {
  isClearable?: boolean;
  onChange: (date: Date) => any;
  selectedDate: Date | undefined;
  showPopperArrow?: boolean;
}

const DatePicker = ({
  selectedDate,
  onChange,
  isClearable = false,
  showPopperArrow = false,
  ...props
}: Props & any) => {
  return (
    // if you don't want to use chakra's colors or you just wwant to use the original ones,
    // set className to "light-theme-original" ↓↓↓↓
    <ReactDatePicker
      locale={ptBR}
      selected={selectedDate}
      onChange={onChange}
      isClearable={isClearable}
      showPopperArrow={showPopperArrow}
      className="react-datapicker__input-text" //input is white by default and there is no already defined class for it so I created a new one
      {...props}
    />
  );
};

export default DatePicker;
